import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Overview from '../overview/Overview';
import Character from '../character/character';
import Review from '../review/review';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width:'100vw',
  },
}));

export default function FullWidthTabs() {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="secondary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab style={{fontSize:'30px', fontWeight:'Bold'}} label="Overview" {...a11yProps(0)} />
          <Tab style={{fontSize:'30px', fontWeight:'Bold'}} label="Character" {...a11yProps(1)} />
          <Tab style={{fontSize:'30px', fontWeight:'Bold'}} label="Review" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
 
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Overview />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Character />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
         <Review />
        </TabPanel>
  
    </div>
  );
}

